var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card"},[_c('div',{staticClass:"info-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"info-value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }